const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

function requestActivities() {
    return {
        type: actionTypes.BROKER_GET_MARKET_TREND_ACTIVITY_REQUEST
    };
}

function requestActivitiesSuccess(response) {
    return {
        type: actionTypes.BROKER_GET_MARKET_TREND_ACTIVITY_SUCCESS,
        payload: {
            data: response  || []
        }
    };
}

function requestActivitiesFailure(response) {
    return {
        type: actionTypes.BROKER_GET_MARKET_TREND_ACTIVITY_FAILURE,
        payload: {
            data: response
        }
    };
}

const getActivities = () => (dispatch) => {

        const requestData = {
            query: {
                method: '2', // @harcoded
                instrumentCategories: '1' // @harcoded
            }
        };

        dispatch(requestActivities());

        return APIGet(dispatch, apiURLBuilder.getURL('brokerMarketsTrendActivity') , requestData)
            .then(function(response) {
                dispatch(requestActivitiesSuccess(response));
            }, function(response) {
                dispatch(requestActivitiesFailure(response))
            }
        );
}

function requestActivitiesByTrending() {
    return {
        type: actionTypes.BROKER_GET_MARKET_TREND_ACTIVITY_BY_TRENDING_REQUEST
    };
}

function requestActivitiesByTrendingSuccess(response) {
    return {
        type: actionTypes.BROKER_GET_MARKET_TREND_ACTIVITY_BY_TRENDING_SUCCESS,
        payload: {
            data: response  || []
        }
    };
}

function requestActivitiesByTrendingFailure(response) {
    return {
        type: actionTypes.BROKER_GET_MARKET_TREND_ACTIVITY_BY_TRENDING_FAILURE,
        payload: {
            data: response
        }
    };
}

const getActivitiesByTrending = () => (dispatch) => {
        const requestData = {
            query: {
                instrumentCategories: 1, // @harcoded
                instrumentsNumber: 5 // @harcoded
            }
        };

        dispatch(requestActivitiesByTrending());

        return APIGet(dispatch, apiURLBuilder.getURL('brokerMarketsTrendActivityByTrending') , requestData)
            .then(function(response) {
                dispatch(requestActivitiesByTrendingSuccess(response));
            }, function(response) {
                dispatch(requestActivitiesByTrendingFailure(response))
            }
        );
}

module.exports = {
    getActivities,
    getActivitiesByTrending
}
